import React from "react";
import { Link } from "react-router-dom";

const Logo = ({ variant = "default", size = "default" }) => {
  const textColor = variant === "light" ? "text-white" : "text-slate-900";
  const accentColor = variant === "light" ? "text-amber-400" : "text-amber-700";
  
  const sizes = {
    small: { icon: 32, heading: "text-xl", sub: "text-[10px]" },
    default: { icon: 44, heading: "text-2xl", sub: "text-[11px]" },
    large: { icon: 72, heading: "text-4xl", sub: "text-sm" }
  };
  
  const s = sizes[size] || sizes.default;

  return (
    <Link to="/" className="flex items-center gap-3 group" data-testid="site-logo">
      <svg
        width={s.icon}
        height={s.icon}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="transition-transform duration-500 group-hover:scale-105"
      >
        {/* Hands */}
        <path
          d="M8 42 C 8 36, 14 32, 20 34 L 32 40 L 44 34 C 50 32, 56 36, 56 42 L 56 50 C 56 54, 53 56, 50 56 L 14 56 C 11 56, 8 54, 8 50 Z"
          fill="currentColor"
          className={accentColor}
          opacity="0.9"
        />
        {/* House */}
        <path
          d="M16 34 L 32 18 L 48 34 L 48 44 L 16 44 Z"
          stroke="currentColor"
          strokeWidth="2.5"
          fill="none"
          className={accentColor}
        />
        <path
          d="M30 14 L 34 14 L 34 20 L 30 20 Z"
          fill="currentColor"
          className={textColor}
          opacity="0.3"
        />
        {/* Heart */}
        <path
          d="M32 40 C 32 40, 24 34, 24 29 C 24 26, 26 24, 28.5 24 C 30 24, 31 25, 32 26.5 C 33 25, 34 24, 35.5 24 C 38 24, 40 26, 40 29 C 40 34, 32 40, 32 40 Z"
          fill="currentColor"
          className={textColor}
        />
      </svg>
      <div className="flex flex-col leading-none">
        <span className={`font-serif ${s.heading} font-bold ${textColor} tracking-tight`}>
          Blessing
        </span>
        <span className={`${s.sub} ${accentColor} font-medium tracking-[0.25em] uppercase mt-1`}>
          Companion Care
        </span>
      </div>
    </Link>
  );
};

export default Logo;
